module.exports = __webpack_public_path__ + "static/img/topRight.c0d08104.png";